<template>
    <section>


        <div class="page">
            <div>
                <h2>Reinstalling ToTok</h2>
                <h3>
                    To delete or reinstall ToTok
                </h3>
                <ol>
                    <li>
                        Touch and hold the ToTok icon on the Home Screen until the icons start to wiggle.
                    </li>
                    <li>
                        Tap the X in the corner of the ToTok icon.
                    </li>
                    <li>
                        Tap Delete to remove the application and all of its data.
                    </li>
                    <li>
                        Press the Home button.
                    </li>
                    <li>
                        Re-download ToTok from the App Store.
                    </li>
                </ol>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>